export const mobile_photo_image_MOCK: any[] = [
  "https://dream-picnic.sfo3.cdn.digitaloceanspaces.com/PICNIC/photo/image-photo-1-v1.jpg",
  "https://dream-picnic.sfo3.cdn.digitaloceanspaces.com/PICNIC/photo/image-photo-3-v1.jpg",
  "https://dream-picnic.sfo3.cdn.digitaloceanspaces.com/PICNIC/photo/image-photo-4-v1.jpg",
  "https://dream-picnic.sfo3.cdn.digitaloceanspaces.com/PICNIC/photo/image-photo-5-v1.jpg",

]